<template>
    <router-view />
</template>

<style lang="sass">
#app
  position: relative
</style>
